import React from 'react';

import { EditIconButton } from 'packages/common-frontend/components/IconButton';

type EditButtonProps = {
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
};
export const EditButton = ({ setIsOpen }: EditButtonProps) => {
  return (
    <EditIconButton
      ariaLabel="edit"
      label="Edit"
      onClick={() => setIsOpen(true)}
    />
  );
};
